import api from '@pray/shared/utils/api';

import { asPrayRadioRehosting, waitForPrayRadioAudioRehost } from './waitForPrayRadioAudioRehost';

type AutoSchedulePrayRadioSlotParams = {
  artistId: string;
  scheduledAt: string;
  onRehosting?: (title: string | null) => void;
};

// Admin-only (PB-38017): the backend picks a random audio source from the
// leader's catalog — a previously-aired radio daily (duplicated) or an audio
// content (copied) — and schedules it through the standard publishing pipeline.
// A pick hosted outside Pray first has its audio copied to Pray (several
// minutes): `onRehosting` fires, and the same episode is scheduled once done.
export async function autoSchedulePrayRadioSlot({
  artistId,
  scheduledAt,
  onRehosting,
}: AutoSchedulePrayRadioSlotParams) {
  if (!artistId) throw Error('Artist ID is required');
  if (!scheduledAt) throw Error('Scheduled At is required');

  const url = `/web/studio/artists/${artistId}/pray-radio-schedule/auto`;
  let response = await api.executePostRequest(url, {
    scheduled_at: scheduledAt,
  });

  const rehosting = asPrayRadioRehosting(response.data);
  if (rehosting) {
    onRehosting?.(rehosting.content?.title ?? null);
    await waitForPrayRadioAudioRehost({ artistId, processId: rehosting.process_id });
    response = await api.executePostRequest(url, {
      scheduled_at: scheduledAt,
      content_id: rehosting.content?.id,
    });
  }

  return response.data;
}
